import { z } from 'zod';

const nutrientField = z
	.string()
	.optional()
	.refine(
		(v) => v === undefined || v === '' || (!Number.isNaN(Number(v)) && Number(v) >= 0),
		'Valor deve ser um número positivo'
	);


const baseSchema = z.object({
	name: z.string().min(1, 'Nome é obrigatório').max(300, 'Nome muito longo (máx. 300 caracteres)'),
	manufacturerId: z.string().min(1, 'Fabricante é obrigatório'),
	category: z.enum(['fertilizer', 'lime', 'conditioner', 'organic', 'special'], {
		error: 'Categoria inválida',
	}),
	applicationMethods: z
		.array(z.enum(['broad', 'irrigation', 'foliar']))
		.min(1, 'Selecione ao menos um modo de aplicação'),
	nature: z.enum(['solid', 'liquid'], { error: 'Natureza inválida' }),
	active: z.boolean(),
	note: z.string().max(480, 'Nota muito longa (máx. 480 caracteres)').optional(),
	N: nutrientField,
	P2O5: nutrientField,
	K2O: nutrientField,
	Ca: nutrientField,
	Mg: nutrientField,
	S: nutrientField,
	C: nutrientField,
	B: nutrientField,
	Cu: nutrientField,
	Fe: nutrientField,
	Mn: nutrientField,
	Zn: nutrientField,
	Mo: nutrientField,
	CaO: nutrientField,
	MgO: nutrientField,
	PRNT: nutrientField,
});

export const FertilizerSchema = baseSchema.superRefine((data, ctx) => {
	const solidNutrientKeys = [
		'N',
		'P2O5',
		'K2O',
		'Ca',
		'Mg',
		'S',
		'C',
		'B',
		'Cu',
		'Fe',
		'Mn',
		'Zn',
		'Mo',
		'CaO',
		'MgO',
	];

	if (data.category === 'fertilizer') {
		const nutrientKeys = ['N', 'P2O5', 'K2O', 'Ca', 'Mg', 'S', 'B', 'Cu', 'Fe', 'Mn', 'Zn', 'Mo'];
		const hasNutrient = nutrientKeys.some((k) => {
			const val = data[k as keyof typeof data];
			return typeof val === 'string' && val !== '' && Number(val) > 0;
		});
		if (!hasNutrient) {
			ctx.addIssue({
				code: 'custom',
				message: 'Você deve definir ao menos uma garantia nutricional.',
				path: ['N'],
			});
		}
	}

	if (data.nature === 'solid') {
		for (const key of solidNutrientKeys) {
			const val = data[key as keyof typeof data];
			if (typeof val === 'string' && val !== '' && Number(val) > 100) {
				ctx.addIssue({
					code: 'custom',
					message: `${key}: máximo 100% para produtos sólidos`,
					path: [key],
				});
			}
		}
	}
});

export type FertilizerSchemaType = z.infer<typeof baseSchema>;
